import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  selectDetailsData,
  selectListFetchData,
} from 'src/core/redux/selectors';
import { User } from 'src/core/models';
import { FetchData } from 'src/core/components';
import LocalStorageService from 'src/core/services/LocalStoregeService';
import { config } from 'src/constants';
import { DesignType } from 'src/models';

import { fetchUserDetails, resetUserDetails } from './actions';
import App from './AppComponent';

const AppContainer = ({
  isFetching,
  fetched,
  designTypeDataFetched,
  error,
  fetchData,
  resetData
}) => {
  useEffect(() => {
    if (designTypeDataFetched && !(config.isDevEnv)) {
      window.showGlobalFooter();
    }
  }, [designTypeDataFetched]);

  return (
    <FetchData
      isFetching={isFetching}
      fetched={fetched}
      error={error}
      fetchData={fetchData}
      resetData={resetData}
    >
      <App />
    </FetchData>
  );
};

AppContainer.propTypes = {
  isFetching: PropTypes.bool,
  fetched: PropTypes.bool,
  designTypeDataFetched: PropTypes.bool,
  error: PropTypes.string,
  fetchData: PropTypes.func.isRequired,
  resetData: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
  LocalStorageService.removeItem('loggedUser');

  const userType = selectDetailsData(User, 'type')(state);
  const userDetails = selectDetailsData(User)(state);

  LocalStorageService.setLoggedUser(
    new User({
      ...userDetails,
      isAnonymous: userType.isAnonymous
    })
  );

  const fetchDataProps = selectListFetchData(User)(state);
  const designTypeDataProps = selectListFetchData(DesignType)(state);

  return {
    fetched: config.isDevEnv ? true : fetchDataProps.fetched,
    designTypeDataFetched: designTypeDataProps.fetched,
    isFetching: config.isDevEnv ? false : fetchDataProps.isFetching,
    // eslint-disable-next-line no-nested-ternary
    error: config.isDevEnv ? undefined : userType.isAnonymous ? undefined : fetchDataProps.error,
  };
};

const mapDispatchToProps = {
  fetchData: fetchUserDetails,
  resetData: resetUserDetails
};

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
